import React from 'react';
import Chart from 'react-google-charts';
import {
  calclateAssrtControl,
  getAssetValue,
} from 'components/features/utils/chart';
import { AssetTransitions } from 'components/features/target-achievement-support/utils/type';

type Props = {
  birthday: Date;
  targetAmount: number;
  assetTransitions: AssetTransitions[];
};

export const SettingTargetChart = (props: Props) => {
  const getNumOfMonth = (value: string): number => {
    const dt = new Date(
      Number(value.slice(0, 4)),
      Number(value.slice(5)) - 1,
      1
    );
    const dtMonths = dt.getFullYear() * 12 + dt.getMonth();
    const birthMonth =
      props.birthday.getFullYear() * 12 + props.birthday.getMonth();
    return (dtMonths - birthMonth) / 12;
  };
  const assrtControl = calclateAssrtControl(
    Math.max(...props.assetTransitions.map(x => x.assetAmount))
  );

  const data = [
    [
      {
        type: 'number',
      },
      {
        type: 'number',
        label: '設定目標額',
      },
      {
        type: 'number',
        label: '計画目標額',
      },
      {
        type: 'number',
        label: '計画（ベンチマーク）',
      },
      {
        type: 'string',
        role: 'annotation',
      },
    ],
    [
      getNumOfMonth(props.assetTransitions[0].dateYM),
      getAssetValue(props.targetAmount, assrtControl.unit),
      null,
      getAssetValue(props.assetTransitions[0].assetAmount, assrtControl.unit),
      '現在',
    ],
    ...props.assetTransitions.map((x, i, arr) => [
      getNumOfMonth(x.dateYM),
      getAssetValue(props.targetAmount, assrtControl.unit),
      i >= 1 &&
      arr[i - 1].assetAmount < props.targetAmount &&
      props.targetAmount <= x.assetAmount
        ? getAssetValue(x.assetAmount, assrtControl.unit)
        : null,
      i === 0 || arr[i - 1].assetAmount < props.targetAmount
        ? getAssetValue(x.assetAmount, assrtControl.unit)
        : null,
      null,
    ]),
  ];

  // lightblue-400
  //const mainLineColor = '#e0f2fe';
  // lightblue-100
  const grdStColor = '#38bdf8';
  // purple-300
  const grdPlColor = '#BA68C8';
  // blue-800
  const grdAtColor = '#1565C0';

  const options = {
    //title: '目標資産推移',
    chartArea: {
      left: 40,
      top: 40,
      right: 20,
      bottom: 25,
      height: '90%',
      width: '100%',
    },
    hAxis: {
      //title: '年齢（歳）',
      format: '###',
      baseline: getNumOfMonth(props.assetTransitions[0].dateYM),
      baselineColor: grdStColor,
      gridlines: {
        interval: [1, 5],
      },
      //textStyle: {
      //  fontSize: 6,
      //},
    },
    vAxis: {
      //title: '資産（万円）',
      //format: '#,###万円',
      //textStyle: {
      //  fontSize: 6,
      //},
    },
    seriesType: 'line',
    series: {
      0: {
        color: grdStColor,
        areaOpacity: 0.8,
      },
      1: {
        type: 'scatter',
        color: grdPlColor,
        pointSize: 10,
        areaOpacity: 0.8,
      },
      2: {
        color: grdPlColor,
        //lineWidth: 4,
        lineDashStyle: [4, 4],
        areaOpacity: 0.8,
      },
    },
    annotations: {
      textStyle: {
        //fontName: 'Times-Roman',
        //fontSize: 18,
        bold: true,
        //italic: true,
        // The color of the text.
        color: grdAtColor,
        //// The color of the text outline.
        //auraColor: '#d799ae',
        // The transparency of the text.
        opacity: 0.8,
      },
      style: 'point',
    },
    legend: {
      position: 'top',
      textStyle: {
        fontSize: 8,
      },
    },
    crosshair: { trigger: 'both' },
  };

  const formatters: {
    column: number;
    type:
      | 'ArrowFormat'
      | 'BarFormat'
      | 'ColorFormat'
      | 'DateFormat'
      | 'NumberFormat'
      | 'PatternFormat';
    options?: Record<string, unknown>;
  }[] = [
    {
      type: 'NumberFormat',
      column: 0,
      options: {
        pattern: '###',
        suffix: '歳',
      },
    },
    {
      type: 'NumberFormat',
      column: 1,
      options: {
        pattern: '#,###',
        suffix: assrtControl.unitYen,
      },
    },
    {
      type: 'NumberFormat',
      column: 2,
      options: {
        pattern: '#,###',
        suffix: assrtControl.unitYen,
      },
    },
    {
      type: 'NumberFormat',
      column: 3,
      options: {
        pattern: '#,###',
        suffix: assrtControl.unitYen,
      },
    },
  ];

  return (
    <Chart
      chartLanguage="ja"
      chartType="ComboChart"
      data={data}
      width="100%"
      height="250px"
      options={options}
      formatters={formatters}
    />
  );
};
